module.exports = __webpack_public_path__ + "media/bootstrap-icons/upload-43c06bcf.svg";